module.exports = __webpack_public_path__ + "img/1609.7fa59c53.png";